import { render, staticRenderFns } from "./CarItem.vue?vue&type=template&id=e1a5a47a"
import script from "./CarItem.vue?vue&type=script&lang=js"
export * from "./CarItem.vue?vue&type=script&lang=js"
import style0 from "./CarItem.vue?vue&type=style&index=0&id=e1a5a47a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports